// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2FOtZ","icon":"SortAdornment_icon__1AaZC","up":"SortAdornment_up__31MSJ","down":"SortAdornment_down__2O8TG","active":"SortAdornment_active__3DH7Z"};